import { render } from "./AnimalJourney.vue?vue&type=template&id=da478bd6&scoped=true"
import script from "./AnimalJourney.vue?vue&type=script&lang=js"
export * from "./AnimalJourney.vue?vue&type=script&lang=js"

import "./AnimalJourney.vue?vue&type=style&index=0&id=da478bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da478bd6"]])

export default __exports__